import { render, staticRenderFns } from "./editBeneficiary.vue?vue&type=template&id=2f79c7a8&scoped=true&"
import script from "./editBeneficiary.vue?vue&type=script&lang=ts&"
export * from "./editBeneficiary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f79c7a8",
  null
  
)

export default component.exports